<!-- Hero -->
<section class="hero-dark">
  <div class="max-w-4xl mx-auto px-6 py-14 lg:py-20 text-center relative z-10">
    <h1 class="hero-title">
      {{ "innovation_page.title" | translate }}
    </h1>
    <p class="hero-subtitle">
      {{ "innovation_page.subtitle" | translate }}
    </p>
  </div>
</section>

<!-- Mission + Canvas -->
<section class="canvas-section">
  <div class="max-w-5xl mx-auto px-6">
    <div class="canvas-layout">
      <div class="canvas-text" #reveal>
        <h2 class="gradient-heading section-heading mb-4">
          {{ "innovation_page.mission_title" | translate }}
        </h2>
        <p class="body-text">
          {{ "innovation_page.mission_text" | translate }}
        </p>
      </div>
      <div class="canvas-wrap">
        <app-innovation-particle-canvas></app-innovation-particle-canvas>
        <p class="canvas-hint">move &amp; click</p>
      </div>
    </div>
  </div>
</section>

<!-- Services -->
<section class="services-section">
  <div class="max-w-5xl mx-auto px-6">
    <h2 class="gradient-heading section-heading text-center mb-10" #reveal>
      {{ "innovation_page.services_title" | translate }}
    </h2>

    <div class="services-grid">
      @for (item of serviceItems; track item.key; let i = $index) {
        <div class="service-card" #reveal [style.transition-delay]="(i * 60) + 'ms'">
          <div class="card-icon">
            <ng-icon [name]="item.icon"></ng-icon>
          </div>
          <h3>{{ "innovation_page.services." + item.key + ".title" | translate }}</h3>
          <p>{{ "innovation_page.services." + item.key + ".description" | translate }}</p>
        </div>
      }
    </div>
  </div>
</section>

<!-- Approach -->
<section class="approach-dark">
  <div class="max-w-4xl mx-auto px-6">
    <h2 class="section-heading text-center mb-10" #reveal>
      {{ "innovation_page.approach_title" | translate }}
    </h2>

    <div class="approach-grid">
      @for (item of approachItems; track item.key; let i = $index) {
        <div class="approach-card" #reveal [style.transition-delay]="(i * 80) + 'ms'">
          <span class="approach-number">{{ '0' + (i + 1) }}</span>
          <div class="approach-icon">
            <ng-icon [name]="item.icon"></ng-icon>
          </div>
          <h3>{{ "innovation_page.approach." + item.key + ".title" | translate }}</h3>
          <p>{{ "innovation_page.approach." + item.key + ".description" | translate }}</p>
        </div>
      }
    </div>
  </div>
</section>

<!-- Values + Why -->
<section class="combined-section">
  <div class="max-w-5xl mx-auto px-6">
    <!-- Values -->
    <h2 class="gradient-heading section-heading text-center mb-8" #reveal>
      {{ "innovation_page.drives_title" | translate }}
    </h2>

    <div class="values-grid mb-16">
      @for (item of valuesItems; track item.key; let i = $index) {
        <div class="value-card" #reveal [style.transition-delay]="(i * 60) + 'ms'">
          <ng-icon [name]="item.icon" class="value-icon"></ng-icon>
          <h3>{{ "innovation_page.drives." + item.key + ".title" | translate }}</h3>
          <p>{{ "innovation_page.drives." + item.key + ".description" | translate }}</p>
        </div>
      }
    </div>

    <!-- Why Partner -->
    <h2 class="gradient-heading section-heading text-center mb-8" #reveal>
      {{ "innovation_page.why_title" | translate }}
    </h2>

    <div class="why-grid">
      @for (item of differentiatorItems; track item.key; let i = $index) {
        <div class="why-card" #reveal [style.transition-delay]="(i * 80) + 'ms'">
          <span class="why-number">{{ '0' + (i + 1) }}</span>
          <h3>{{ "innovation_page.why." + item.key + ".title" | translate }}</h3>
          <p>{{ "innovation_page.why." + item.key + ".description" | translate }}</p>
        </div>
      }
    </div>
  </div>
</section>

<!-- CTA -->
<section class="cta-dark">
  <div class="max-w-3xl mx-auto px-6 text-center" #reveal>
    <h2>{{ "innovation_page.cta_title" | translate }}</h2>
    <p class="cta-sub">{{ "innovation_page.cta_subtitle" | translate }}</p>
    <a class="cta-btn" langRouterLink="contact_us">
      {{ "innovation_page.cta_button" | translate }}
    </a>
  </div>
</section>
